export default "__VITE_ASSET__1qo4sKvs__"